export const BODY = window.document.body;

/**
 * @param {string[]} Classes to add or remove in the body element
 */
export function removeBodyClass(classname) {
  if (classname) {
    classname.forEach(name => BODY.classList.remove(name));
  }
}

/**
 * @param {string[]} Classes to add or remove in the body element
 */
export function setBodyClass(classname) {
  if (classname) {
    classname.forEach(name => BODY.classList.add(name));
  }
}
